var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading-wrapper"},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("../../assets/img/loading-no-bg.gif"),"alt":"loading-icon"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }